module.exports = __webpack_public_path__ + "img/img-spadegaming.476bd868.png";